import { render, staticRenderFns } from "./VendorLocations.vue?vue&type=template&id=5b6f44d4&scoped=true"
import script from "./VendorLocations.vue?vue&type=script&lang=ts"
export * from "./VendorLocations.vue?vue&type=script&lang=ts"
import style0 from "./VendorLocations.vue?vue&type=style&index=0&id=5b6f44d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f44d4",
  null
  
)

export default component.exports